import { ShopkeepersRepository } from 'src/repositories/users/shopkeepers.repository';
import { shopkeeperManager, shopkeepersListTypeItem } from 'src/types/users';
import { api } from 'src/utils/axios';
import { create } from 'zustand';

type States = {
  isLoadingShopkeepersList: boolean;
  isLoadingShopkeeperDetails: boolean;
  isLoadingUpdateShopkeeper: boolean;
  isLoadingRegisterShopkeeper: boolean;
  shopkeepersList: shopkeepersListTypeItem[];
  shopkeeperDetails: shopkeeperManager | null;
};

type Actions = {
  getShopkeepersList: () => Promise<void>;
  getShopkeeperDetails: (id: string) => Promise<void>;
  updateShopkeeper: (shopkeeper: shopkeeperManager) => Promise<void>;
  registerShopkeeper: (shopkeeper: shopkeeperManager) => Promise<void>
  resetShopkeeperToEdit: () => void
};

type Shopkeepers = Actions & States;

const initialValues = {
  isLoadingShopkeepersList: false,
  isLoadingShopkeeperDetails: false,
  isLoadingUpdateShopkeeper: false,
  isLoadingRegisterShopkeeper: false,
  shopkeepersList: [],
  shopkeeperDetails: null,
};

const shopkeepersRepository = new ShopkeepersRepository(api);

export const useShopkeepersStore = create<Shopkeepers>((set: any, get: any) => ({
  ...initialValues,

  getShopkeepersList: async () => {
    set({ isLoadingShopkeepersList: true });
    const response = await shopkeepersRepository.getShopkeepersList();

    if (response.isLeft()) {
      set({ isLoadingShopkeepersList: false });
      throw new Error(response.value.message);
    } else {
      set({ shopkeepersList: response.value, isLoadingShopkeepersList: false });
    }
  },

  getShopkeeperDetails: async (id) => {
    set({ isLoadingShopkeeperDetails: true });
    const response = await shopkeepersRepository.getShopkeeperDetails(id);

    if (response.isLeft()) {
      set({ isLoadingShopkeeperDetails: true });
      throw new Error(response.value.message);
    } else {
      set({ shopkeeperDetails: response.value, isLoadingShopkeeperDetails: false });
    }
  },

  updateShopkeeper: async (shopkeeper) => {
    set({ isLoadingUpdateShopkeeper: true });
    const response = await shopkeepersRepository.updateShopkeeper(shopkeeper);

    if (response.isLeft()) {
      set({ isLoadingUpdateShopkeeper: false });
      throw new Error(response.value.message);
    } else {
      set({ isLoadingUpdateShopkeeper: false });
    }
  },

  registerShopkeeper: async (shopkeeper) => {
    set({ isLoadingRegisterShopkeeper: true });
    const response = await shopkeepersRepository.registerShopkeeper(shopkeeper);

    if (response.isLeft()) {
      set({ isLoadingRegisterShopkeeper: false });
      throw new Error(response.value.message);
    } else {
      set({ isLoadingRegisterShopkeeper: false });
    }
  },

  resetShopkeeperToEdit: () => {
    set({ shopkeeperDetails: null })
  }
}));
